export { default } from './InputsLabelText';
